module.exports = __webpack_public_path__ + "media/styles/images/png/airplane-white-33f7a0589d1f6ff7dbfe429f7c169a33.png";